<style scoped>
.cannel-btn {
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    color: #212121;
}

.textl {
    text-align: left;
}

.iframe-sty {
    width: 100%;
    border: none;
    height: 600px;

}

.flow {
    background: #fff;
    padding-left: 20px;
    margin-top: 4px;
}

.pdt100 {
    padding-bottom: 100px !important;
}

.header {
    background: #fff;
    margin: 4px 0;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    padding: 0 16px;

}

.header .back {
    background: #FFFFFF;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    width: 60px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
    cursor: pointer;
}

.import-title {
    text-align: left;
    background: #fff;
    padding: 10px 16px;
    font-size: 16px;
}

.import-title.second {
    margin-top: 4px;
}

.header .title {
    text-align: center;
    flex: 1;
}

.customer-information {
    background: #fff;
    padding-bottom: 0px;
    font-size: 14px;
}

.customer-information .cols {
    background: #fff;
    display: flex;
    padding: 4px 16px;
    padding-left: 20px;
}

.customer-information .col-itms {
    display: flex;
    /* align-items: center; */
    margin-left: 20px;
    margin-bottom: 10px;
}

.customer-information .col-itms .title {
    width: 120px;
    text-align: right;
    color: #666;
    /* margin-right: 16px; */
}

.customer-information .col-itms.second {
    margin-left: 100px;
}

.customer-information .col-itms .title span {
    color: red;
    display: none;
}

.import-new-wrap {
    padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
    text-align: left;
    padding-left: 170px;

}

.import-new-wrap .col-itms {
    align-items: baseline;
}

.operte-btns {
    background: #fff;
    margin-top: 4px;
    display: flex;
    justify-content: center;
    padding: 25px 0;

}

.operte-btns .btn {
    padding: 5px 18px;
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 2px;
    cursor: pointer;

}

.operte-btns .btn.save {
    margin: 0 10px;
    border: 1px solid rgba(79, 161, 164, 1);
    color: rgba(79, 161, 164, 1);
    cursor: pointer;
}

.submit {
    border: 1px solid rgba(79, 161, 164, 1);
    background: rgba(79, 161, 164, 1);
    color: #fff;
    cursor: pointer;
}

.detail-btn {
    font-size: 14px;
    color: #4FA1A4;
    margin-left: 30px;
    cursor: pointer;
}

.file {
    display: flex;
    margin-bottom: 14px;
    text-align: left;
    align-items: center;
}

.file img {
    width: 32px;
    height: 32px;
    margin-right: 10px;
}

.pics img {
    width: 100px;
    height: 100px;
    margin-right: 6px;
    border: 1px solid #f2f2f2;
    cursor: pointer;
    border-radius: 6px;

}
</style>

<template>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
        <div class="header">
            <div class="back" @click="$router.go(-1)">返回</div>
            <div class="title">停线详情</div>
        </div>
        <div class="import-title second">申请信息</div>
        <div class="customer-information">
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>申请人：</div>
                    <div class="label textl">{{ detail.applyStaffName }}</div>
                </div>
                <div class="col-itms">
                    <span style="margin:0 30px 0 20px;color:#E5E5E5;">|</span>
                    <div>提交时间：</div>
                    <div class="label  textl">{{ detail.inputTime | getTimeDate }}</div>
                    <span style="margin:0 20px 0 30px;color:#E5E5E5;">|</span>
                </div>
                <div class="col-itms">
                    <div>所在部门：</div>
                    <div class="label  textl">{{ detail.organisationName }}</div>
                </div>
            </div>

        </div>
        <div class="import-title second">详细信息</div>
        <div class="customer-information">
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>停线原因：</div>
                    <div class="label w300 textl">{{ transformCodeToName(detail.lineStopRuleGuid) }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>具体原因：</div>
                    <div class="label w300 textl">{{ detail.stopReasonDefinite || '-' }}</div>
                </div>
            </div>
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>活动参与人员：</div>
                    <div class="label w300 textl">{{ formatStaff(detail.lineStopApplyStaffList) }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>备注：</div>
                    <div class="label w300 textl">{{ detail.memo || '-' }}</div>
                </div>
            </div>
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>是否为首次申请：</div>
                    <div class="label w300 textl">{{ detail.isFirstApply == 'Y' ? '是' : '否' }}</div>
                </div>
            </div>
            <template v-if="detail.lineStopApplyDetails">
                <div class="cols">
                    <div class="col-itms">
                        <div class="title">
                            <span>*</span>停线明细（{{ detail.lineStopApplyDetails && detail.lineStopApplyDetails.length }}条）</div>
                    </div>
                </div>

                <div class="cols" v-for="(item, index) in detail.lineStopApplyDetails" :key="index">
                    <div class="col-itms">
                        <div class="title"><span>*</span>停线时间{{ index + 1 }}：</div>
                        <div class="label textl">停线时间：{{ item.stopTime }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;回补时间：{{
                            item.amendTime||'-' }}</div>
                    </div>
                </div>
            </template>


            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>附件：</div>
                    <div class="label  textl pics">
                            <img @click="onPreview(item.url)" :src="item.url" v-for="(item, index) in attaches"
                            :key="index" />
                    </div>
                </div>
            </div>
        </div>

        <!-- start of 流程审批 -->
        <div class="back-color-fff mt-4 pb-16"  v-show="iframeSh">
            <!-- <span class="form-title">流程审批</span> -->
            <div class="flow">
                <iframe scrolling="no"  :src="iframeSrc" class="iframe-sty"></iframe>
            </div>
        </div>
        <!-- end of 流程审批 -->
        <el-dialog :visible.sync="dialogVisible">
            <img width="200" :src="dialogImageUrl" alt="">
        </el-dialog>
        <!-- start of bottom-btn -->
        <div class="back-color-fff submit_btn_wrap">
            <el-button type="defalut" class="cannel-btn" size="mini" @click="$router.go(-1)">取消</el-button>
            <el-button type="danger" size="mini" v-show="getBtnState('approval') == 'approval'"
                @click="reject()">驳回</el-button>
            <el-button type="primary" size="mini" v-show="getBtnState('approval') == 'approval'"
                @click="pass()">通过</el-button>
        </div>
        <!-- end of bottom-btn -->
                <!-- end of dialog-驳回 -->
                <el-dialog title="填写驳回备注" :visible.sync="rejectDialogVisible" width="30%" top="15%">
            <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
            </span>
        </el-dialog>
        <!-- end of dialog-驳回 -->

        <!-- end of dialog-通过 -->
        <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
            <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest" maxlength="100">
            </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
            </span>
        </el-dialog>
        <!-- end of dialog-通过 -->
        <el-image-viewer v-if="showViewer" :on-close="() => { showViewer = false }" :url-list="srcLists" />
    </div>
</template>
<script>
import workFlowCommon from '@/uilt/workFlowCommon';
import { bpmnroute } from '@/api/apiRoute';
export default {
    components: {
        'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
    },
    data() {
        return {
            showViewer: false,
            dialogVisible: false,
            dialogImageUrl: '',
            leaveTypeList: [
                {
                    label: '事假',
                    value: '1'
                },
                {
                    label: '病假',
                    value: '2'
                },
                {
                    label: '事假',
                    value: '3'
                },
                {
                    label: '年假',
                    value: '4'
                },
                {
                    label: '婚假',
                    value: '5'
                },
                {
                    label: '丧假',
                    value: '6'
                },
                {
                    label: '陪产假',
                    value: '7'
                },
                {
                    label: '调休假',
                    value: '8'
                },
                {
                    label: '哺乳假',
                    value: '9'
                }
            ],
            fullscreenLoading: false,
            detail: {},
            attaches: [],
            reasonList: [],
            passDialogVisible:null,
            rejectDialogVisible:null,
            approveSuggest:null,
            iframeSh:false,
            iframeSrc:null


        }
    },
    watch: {

    },
    created() {
        this.getDetail();

    },
    methods: {
        onPreview(img) {
            this.showViewer = true;
            this.srcLists = [];
            let imgSrcIndex;
            this.attaches.forEach((item) => {
                this.srcLists.push(item.url);
            });
        
            this.srcLists.forEach((item, index) => {
                if (img == item) {
                    imgSrcIndex = index;
                }
            })
            console.log( this.srcLists)
            //大图预览从点击的那张开始
            let tempImgList = [...this.srcLists];
            let temp = [];
            for (let i = 0; i < imgSrcIndex; i++) {
                temp.push(tempImgList.shift());
            }
            console.log(temp)
            this.srcLists = tempImgList.concat(temp);

        },
        getBtnState(btnType) {
            if (this.$route.query.bizApproveVO&&this.$route.query.isNeedApprove==1) {
                let userinfo = JSON.parse(localStorage.userInfo);
                let bizApproveVO = JSON.parse(this.$route.query.bizApproveVO)
                this.iframeSh = true;
                this.iframeSrc = bpmnroute + '/iframeBpmn?processInstanceId=' + bizApproveVO.camundaInstanceId + '&camundaDeploymentId=' + bizApproveVO.camundaDeploymentId + '&token=' + localStorage.token;
                return workFlowCommon.getListBtnState(btnType, bizApproveVO.approveState, bizApproveVO.staffGuid, bizApproveVO.approveStaffGuids, userinfo.staffGuid, bizApproveVO.approveState);
            }
        },
        transformCodeToName(guid) {
            let name = '-'
            console.log(this.reasonList)
            console.log(guid)
            this.reasonList && this.reasonList.forEach(item => {
                if (item.value == guid) {
                    name = item.label;
                }
            })
            return name;
        },
        formatStaff(lineStopApplyStaffList) {
            let list = [];
            lineStopApplyStaffList && lineStopApplyStaffList.forEach(item => {
                list.push(item.staffName);
            })
            return list.join('、')||'-';
        },
        getReasonList(tenantGuid) {
            let req = {
                tenantGuid: tenantGuid,
                pageIndex: 1,
                pageSize: -1
            }
            this.api.postJson(`/${serverConfig.msConfigureService}/line-stop-rule/list`, req).then(resp => {
                let data = resp.data.data.records;
                this.reasonList = [];
                if (!data) return;
                data.forEach(item => {
                    this.reasonList.push({
                        label: item.stopReason,
                        value: item.guid
                    })
                })
            })
        },
        getDetail() {
            let self = this;
            if (!this.$route.query.guid) return;
            self.api.get(`/${serverConfig.msSalesPerformService}/line-stop-apply/detail/${this.$route.query.guid}`).then((
                res) => {
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.detail = res.data.data;
                    let attaches = [];
                    this.getReasonList(this.detail.tenantGuid)
                    if (!this.detail.attaches) return;
                    this.detail.attaches.forEach(itme => {
                        attaches.push({
                            name: itme.fileName,
                            url: itme.path
                        })
                    })

                    this.attaches = attaches;
                } else {
                    self.$message.error(res.data.msg);
                }
            });
        },
            /**
         * 保存
         */
         reject() {
            this.rejectDialogVisible = true;
            this.approveSuggest = '';
        },
        /**
         * 提交
         */
        pass() {
            this.passDialogVisible = true;
            this.approveSuggest = '';
        },
            /**
         * 驳回提交
         */
         toRejectSubmit() {
            if (!this.approveSuggest) {
                return this.$message.error('请填写驳回理由')
            }
            let userInfo = JSON.parse(localStorage.userInfo);
            let { bizApproveVO } = this.detail;
            let query = {
                guid: bizApproveVO.approveGuid,
                flowType: bizApproveVO.flowType,
                approveSuggest: this.approveSuggest,
                approveStaffGuid: userInfo.staffGuid,
            };
            this.fullscreenLoading = true;
            this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.passDialogVisible = false;
                    this.approveSuggest = '';
                    this.$message.success('驳回成功！');
                    this.$router.go(-1);
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        /**
         * 通过提交
         */
        toPassSubmit() {
            let userInfo = JSON.parse(localStorage.userInfo);
            let { bizApproveVO } = this.detail;
            let query = {
                guid: bizApproveVO.approveGuid,
                flowType: bizApproveVO.flowType,
                approveSuggest: this.approveSuggest,
                approveStaffGuid: userInfo.staffGuid,
            };
            this.fullscreenLoading = true;
            this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
                this.fullscreenLoading = false;
                if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                    this.passDialogVisible = false;
                    this.approveSuggest = '';
                    this.$message.success('审批通过！');
                    this.$router.go(-1);
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
    }
};
</script> 